import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DailyReport, Project } from 'src/app/shared/models';
import { AppHttpService } from 'src/app/shared/services';
import { saveAs } from 'file-saver';
import { environment as ENV } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ReportService {

  constructor(
    private appHttpService: AppHttpService,
    private httpClient: HttpClient
  ) { }


  fetchProjects(): Promise<Project[]> {
    const qp = {
      all: 'all',
      include: [
        'sites',
        'accounts',
      ],
      start: 0,
      total: 1000,
    };
    return this.appHttpService.getService(`/v1/project`, qp).toPromise()
      .then((resp: any) => {
        if (resp.data && Array.isArray(resp.data)) {
          return resp.data.map(r => new Project(r));
        }
        throw new Error('Error parsing response');
      });
  }

  fetchDailyReports(qp: any = {}): Promise<any> {
    return this.appHttpService.getService(`/v1/report`, qp).toPromise()
      .then((resp: any) => {
        if (resp.data && Array.isArray(resp.data)) {
          return {
            reportHtml: resp?.reportHtml,
            drs: resp.data.map(r => new DailyReport(r))
          };
        }
        throw new Error('Error parsing response');
      });
  }

  downloadReport(project, qp: any = {}) {
    const extension = qp.format === 'excel' ? 'xlsx' : 'pdf';

    return this.appHttpService.getService(`/v1/report/project/${project.id}/download`, qp, { responseType: 'blob' })
      .toPromise()
      .then((resp: Blob) => {
        return saveAs(resp, `Download Report.${extension}`);
      });
  }

  /**
   * Generate PDF from HTML using backend Puppeteer
   * @param reportId - The report template ID
   * @param html - The HTML string to convert to PDF
   * @param metadata - Optional metadata (inspector, date, groupKey, reportId, projectId)
   * @returns Promise<{blob: Blob, filename: string}> - The generated PDF blob and filename from backend
   */
  generatePdfFromHtml(
    reportId: string,
    html: string,
    metadata?: { inspector?: string; date?: string; groupKey?: string; reportId?: number; projectId?: string; form_number?: string }
  ): Promise<{ blob: Blob; filename: string }> {
    const body = {
      html,
      metadata: metadata || {}
    };

    const url = `${ENV.API_ENDPOINT}/v2/report/${reportId}/generate-pdf`;

    // Use HttpClient with observe: 'response' to capture headers including Content-Disposition
    return this.httpClient.post(url, body, { observe: 'response', responseType: 'blob' })
      .toPromise()
      .then((response) => {
        const blob = response.body;

        // Extract filename from Content-Disposition header
        let filename = 'report.pdf';
        const contentDisposition = response.headers.get('Content-Disposition');
        if (contentDisposition) {
          // Parse filename from header: 'attachment; filename="CDOT Form 103 09-30-2025 TA.pdf"'
          const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/['"]/g, '');
          }
        }

        return { blob, filename };
      })
      .catch((error) => {
        console.error('Error in generatePdfFromHtml:', error);
        throw error;
      });
  }

}
